import React from 'react'
import styles from "./aboutuscomp.module.css"
import { useNavigate } from 'react-router-dom'

const Aboutuscomp = ({aboutUsData}) => {
  const navigate = useNavigate()
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <p className={styles.heading}>About us</p>
        <p className={styles.subheding}> {aboutUsData?.title}</p>
        <p className={styles.head}>{aboutUsData?.description}</p>
        <button className={styles.btn1} onClick={() => navigate('/aboutus')}>Know More</button>

      </div>
      <div className={styles.right}>
        <div className={styles.box}>
          <img src={aboutUsData?.image1} alt="Logo" className={styles.mainImg_1} />
        </div>
        <div className={styles.box2}>
          <img src={aboutUsData?.image2}alt="Logo" className={styles.mainImg_2} />
        </div>
      </div>

    </div>
  )
}

export default Aboutuscomp